export class TotalBalanceConverter {
  totalConverter = (data) => ({
    list: data.data,
    total_deposit: data.total_deposit,
    total_withdrawal: data.total_withdrawal,
  });
}
